/**
 * options:
 * i: boolean
 * limit: number
 * */
import Diacritic from './-formatters/diacritics'

const diacritic = Diacritic()
export default defineNuxtPlugin(() => {
  return {
    provide: {
      searchObjects: (items: any, keys: Array<string> | string, keyWord: string, options?: { [key: string]: any }) => {
        const results: any[] = []
        const limit = options?.limit || 100

        if (typeof keys === 'string') {
          keys = [keys]
        }

        keys = keys.filter((key) => !!key)

        const escapedKeyWord = escapeRegExp(keyWord)
        let keyWordRegex = keyWord ? new RegExp(escapedKeyWord.replace(/\s/g, '(.*)')) : ''

        if (options?.i) {
          keyWordRegex = keyWord ? new RegExp(escapedKeyWord.replace(/\s/g, '(.*)'), 'i') : ''
        }

        const foundItems: { [key: string]: any } = {}

        Array.from(items).forEach((item: any) => {
          if (Array.isArray(keys)) {
            keys.forEach((key) => {
              const unaccentedName = diacritic.clean(item[key])

              if (key in item && (item[key].search(keyWordRegex) !== -1 || unaccentedName.search(keyWordRegex) !== -1)) {
                if (results.length >= limit) {
                  return false
                }

                const itemKey = JSON.stringify(item)
                if (!(itemKey in foundItems)) {
                  foundItems[itemKey] = true
                  return results.push(item)
                }
              }
            })
          }

          if (results.length >= limit) {
            return false
          }
        })

        return results
      }
    }
  }
})

const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
